import TableTools from "@/utils/tableTools";
import mesureEnum from "@/model/mesureEnum";
import dimensionEnum from "@/model/dimensionEnum";
import {
  calculatedColumnsEnum,
  alternativeColumnLabelEnum
} from "@/model/columnsEnums";

export const kioskGlobalHelper = {
  dimensions: [
    dimensionEnum.DATE,
    dimensionEnum.KIOSK,
    dimensionEnum.KIOSK_NAME,
    dimensionEnum.SITE,
    dimensionEnum.SITE_NAME,
    dimensionEnum.SITE_CURRENCY,
  ],

  orderByColumns: {
    [dimensionEnum.DATE]: "asc",
    [dimensionEnum.KIOSK_NAME]: "asc"
  },

  getQueries(filters, timeDimension) {

    const queries = [
      {
        query: {
          measures: [
            mesureEnum.PURCHASEHISTORY_AMOUNT,
            mesureEnum.PURCHASEHISTORY_AMOUNTCB,
            mesureEnum.PURCHASEHISTORY_AMOUNTCASH,
            mesureEnum.PURCHASEHISTORY_TOKEN,
            mesureEnum.PURCHASEHISTORY_BONUSTOKEN,
            mesureEnum.PURCHASEHISTORY_COUNTSOLDCARDS,
          ],
          dimensions: this.dimensions,
          timeDimensions: timeDimension
            ? [{ ...timeDimension, dimension: dimensionEnum.PURCHASEHISTORY_DATETIME }]
            : [],
          filters: [
            ...filters,
            TableTools.Helper.getFilterPurchaseHistoryNotBirthday(),
          ],
          order: this.orderByColumns,
        }
      },
      // ATTENTION : Requête liée à pré-aggregation, si modif -> à répercuter dans SnackHistory.js
      {
        query: {
          measures: [
            mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC
          ],
          dimensions: this.dimensions,
          timeDimensions: timeDimension ? [timeDimension] : [],
          filters: [
            ...filters,
            TableTools.Helper.getFilterPurchaseHistoryNotBirthday(),
          ],
          order: this.orderByColumns,
        }
      }
    ];
    return queries;
  },
  addSnackHistoryCbColumns(dataTable) {
    return dataTable.map((data) => {
      TableTools.Helper.renameKey(
        data,
        mesureEnum.SNACKHISTORY_AMOUNT_CB_TTC,
        alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC
      );
      data[calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT] = (data[mesureEnum.PURCHASEHISTORY_AMOUNT] || 0)
        + (data[alternativeColumnLabelEnum.SNACKHISTORY_AMOUNT_CB_TTC] || 0);

      return data;
    });
  },
  addPercentageColumn(dataTable, totalRevenueSite) {
    return dataTable.map((data) => {
      const kioskRevenue = data[calculatedColumnsEnum.RECEIPTS_TOTAL_AMOUNT] || 0;
      data[calculatedColumnsEnum.TOTAL_REVENUE_PERCENT_SITE] = totalRevenueSite ? (kioskRevenue * 100) / totalRevenueSite : 0;

      return data;
    });
  },
};
